import GoogleMapReact from 'google-map-react';
import React from "react";


import * as Api from '../API/API.js';

import poiimg from '../Images/ic_poi.png'
import sensorimg from '../Images/ic_sensor.png'
import fauneimg from '../Images/ic_faune.png'
import floreimg from '../Images/ic_flore.png'

function Map(props) {
  const defaultProps =  {
    center: {
      lat: 50.6315,
      lng: 3.02
    },
    zoom: 16
  };


  const displayMarkers = (todisp, maps, map) => {
    return todisp.map((item) => {
      const markercoords = {lat: item.location.latitude, lng: item.location.longitude};
      var img;
      switch(item.type) {
        case 0:
          img ={
            url: poiimg, // url
            scaledSize: { width: 32, height: 32 } , // size
            origin: new maps.Point(0, 0),
            // The anchor for this image is the base of the flagpole at (0, 32).
            anchor: new maps.Point(32, 32),
        };
        break;
        case 1:
          img ={
            url: sensorimg, // url
            scaledSize: { width: 32, height: 32 } , // size
        };
        break;
        case 2:
          img ={
            url: fauneimg, // url
            scaledSize: { width: 32, height: 32 } , // size
        };
        break;
        default:
          img ={
            url: floreimg, // url
            scaledSize: { width: 32, height: 32 } , // size
        };
        break;
      }
    
      var marker = new maps.Marker({
        position: markercoords,
        map: map,
        title: item.name,
        icon: img
      });

      marker.setMap(map);

      maps.event.addListener(marker, 'click', function(evt){
        console.log("marker is being clicked");
        
        switch(item.type) {
          case 0:
            Api.fetchPointOfInterest(item._id).then(val => {
              console.log("get poi");

              props.setCurrentModalInfosToDisplay(val);
              props.setVisibleModalType(0);
            }).catch(error =>{console.log("fetchPointOfInterest - ERROR");});         
          break;
          case 1:
            Api.fetchSensor(item._id).then(val => {
              console.log("get sensor");

              props.setCurrentModalInfosToDisplay(val);
              props.setVisibleModalType(1);
            }).catch(error =>{console.log("fetchSensor - ERROR");});        
            
          break;
          case 2:
            Api.fetchFauneObservation(item._id).then(val => {
              console.log("get faune obs");
              props.setCurrentModalInfosToDisplay(val);
              props.setVisibleModalType(2);
            }).catch(error =>{console.log("fetchFauneObservation - ERROR");}); 
          break;
          default:
            Api.fetchFloreObservation(item._id).then(val => {
              console.log("get flore obs");

              props.setCurrentModalInfosToDisplay(val);
              props.setVisibleModalType(3);
            }).catch(error =>{console.log("fetchFloreObservation - ERROR");}); 
          break;
        }
        


      }); 
    })
  } 

  const handleApiLoaded = (map, maps) => {

    Api.fetchDistrictCoordinates().then(val => {
      var coordinates = [...val.district_coordinates];
      console.log(coordinates);

      const coords = coordinates.map(item => {
        return { lng: item.longitude, lat: item.latitude };
      });
      console.log(coords);

      var districtPolygon = new maps.Polygon({
        paths: coords,
        strokeColor: "#e0f1e7",
        strokeOpacity: 1,
        strokeWeight: 5,
        fillColor: "#000000",
        fillOpacity: 0
      });
      districtPolygon.setMap(map);

        
    }).catch(error =>{console.log("fetchDistrictCoordinates - ERROR");});


    Api.fetchFauneObservations(3).then(val => {
      console.log(val);
      var fauneObs = val;

      console.log(fauneObs);
      displayMarkers(fauneObs, maps, map);
      
      
    }).catch(error =>{console.log("fetchFauneObservations - ERROR");});

    Api.fetchFloreObservations(3).then(val => {
      console.log(val);
      var floreObs = val;

      console.log(floreObs);
      displayMarkers(floreObs, maps, map);
      
      
    }).catch(error =>{console.log("fetchFloreObservations - ERROR");});


    Api.fetchPointsOfInterest().then(val => {
      console.log(val);
      var pois = val;

      console.log(pois);
      displayMarkers(pois, maps, map);
      
      
    }).catch(error =>{console.log("fetchPointsOfInterest - ERROR");});


    Api.fetchSensors().then(val => {
      console.log(val);
      var sensors = val;
      displayMarkers(sensors, maps, map);
      
      
    }).catch(error =>{console.log("fetchSensors - ERROR");});
        
  }

  function gmOptions(maps) {
    return {
        streetViewControl: false,
        scaleControl: false,
        fullscreenControl: false,
        styles: [{
            featureType: "poi.business",
            elementType: "labels",
            stylers: [{
                visibility: "off"
            }]
        }],
        gestureHandling: "greedy",
        disableDoubleClickZoom: true,
        minZoom: 16,
        maxZoom: 30,

        mapTypeControl: false,
        mapTypeId: maps.MapTypeId.SATELLITE,
        
        zoomControl: true,
        clickableIcons: false  
    }
  }

  return (      
    <div style={{ height: '100%', width: '100%' }}>
      <GoogleMapReact
        bootstrapURLKeys={{ key: process.env.REACT_APP_MAPS_API_KEY }}
        defaultCenter={defaultProps.center}
        defaultZoom={defaultProps.zoom}
        options={gmOptions}
        yesIWantToUseGoogleMapApiInternals //this is important!
        onGoogleApiLoaded={({ map, maps }) => handleApiLoaded(map, maps)}
      >
        
      </GoogleMapReact>
    </div>
  );
}
  
export default Map;
  